import React, { Component } from 'react';

import {Card} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';

import {CardDetails as styles} from './form.css';

import {
  StripeProvider,
  Elements,
  injectStripe,
} from 'react-stripe-elements';

import _CardForm from '../elements/StripeElement';
const CardForm = injectStripe(_CardForm);

import Config from '../../conf';

class CardDetails extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorDialog: this.props.details.stripeError, 
      errMessage: this.props.details.stripeMessage
    }

    this.nextDisabled = this.nextDisabled.bind(this);
    this.next = this.next.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  nextDisabled() {
    const ret = this.props.details.cvc && this.props.details.cardNumber && this.props.details.expiry;
    return !ret || this.state.isLoading;
  }

  next() {
    this.setState({
      isLoading: true
    }, () => {
      this.props.details.stripe.createToken().then((payload) => {
        // Store the Token
        this.props.updateField('stripeToken', payload.token);
        this.props.next();    
      }).catch((err) => {
        this.setState({
          isLoading: false
        });
      });
    });
  }

  closeDialog() {
    this.setState({
      errorDialog: false,
      errMessage: ''
    }, () => {
      this.props.updateField('stripeError', false);
      this.props.updateField('stripeMessage', '');
    });
  }

  render() {
    const actions = [
      <RaisedButton
        label="OK"
        primary={false}
        onTouchTap={this.closeDialog}
        style={styles.dialogButton}
      />
    ];
    
    return (
      <div>
        <Card style={styles.card}>
          <h2 style={styles.title}>Card Details</h2>

          <Dialog
            title="Sorry!"
            actions={actions}
            modal={false}
            open={this.state.errorDialog}
            onRequestClose={this.closeDialog}
            bodyStyle={styles.center}
            titleStyle={styles.center}
            className="counteract-zoom"
          >
            <p>{this.state.errMessage}</p>
          </Dialog>

          <StripeProvider apiKey={Config.STRIPE_API_KEY}>
            <Elements>
              <CardForm 
                details={this.props.details}
                updateField={this.props.updateField}
              />
            </Elements>
          </StripeProvider>
          
          <RaisedButton style={styles.button}
            label="Back" primary={true} onClick={this.props.back} />
          <RaisedButton style={styles.button} 
            label="Next" primary={true} onClick={this.next} 
            icon={this.state.isLoading ? <CircularProgress size={5}/> : null}
            disabled={this.nextDisabled()}
          />
        </Card>
      </div>
    );
  }
}

export default CardDetails;



// WEBPACK FOOTER //
// ./src/app/components/form/CardDetails.js